import { render } from "./syncPersonRowFun.vue?vue&type=template&id=51012c5a&scoped=true&ts=true"
import script from "./syncPersonRowFun.vue?vue&type=script&lang=ts"
export * from "./syncPersonRowFun.vue?vue&type=script&lang=ts"

import "./syncPersonRowFun.vue?vue&type=style&index=0&id=51012c5a&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51012c5a"]])

export default __exports__